import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  :root {
    --header-height: 48px;

    /* Safe area insets for notched devices */
    --safe-area-inset-top: env(safe-area-inset-top, 0px);
    --safe-area-inset-right: env(safe-area-inset-right, 0px);
    --safe-area-inset-bottom: env(safe-area-inset-bottom, 0px);
    --safe-area-inset-left: env(safe-area-inset-left, 0px);

    /* Touch target minimum size */
    --touch-target-minimum: 44px;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    /* Prevent horizontal scroll on mobile */
    overflow-x: hidden;
  }

  body {
    font-family: ${({ theme }) => theme.typography.fontFamily.sans};
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
    line-height: ${({ theme }) => theme.typography.lineHeight.normal};
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: ${({ theme }) => theme.colors.background.secondary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* Prevent horizontal scroll on mobile */
    overflow-x: hidden;
    /* Support safe-area padding for notched devices */
    padding-left: var(--safe-area-inset-left);
    padding-right: var(--safe-area-inset-right);

    @media print {
      background-color: transparent !important;
    }
  }

  * {
    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.border.focus};
      outline-offset: 2px;
      outline-style: solid;
    }
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    background: none;
  }

  input, textarea, select {
    font-family: inherit;
    font-size: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  /* Hide scrollbars while maintaining scroll functionality */
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background: transparent;
  }

  * {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  /* Respect user's motion preferences */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  /* Typography utilities */
  .text-uppercase {
    text-transform: uppercase;
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.uppercase};
  }

  /* Animations */
  ${({ theme }) => theme.animations.popIn}
  ${({ theme }) => theme.animations.fadeIn}
  ${({ theme }) => theme.animations.slideInLeft}
  ${({ theme }) => theme.animations.rotate}
`
